{
  "sellGradeMult": {
    "common": 1,
    "magic": 1.5,
    "rare": 3,
    "unique": 5
  },
  "sellPlusMult": 0.25,
  "npcInteractRangeM": 5,
  "upgradeBroadcastMinPlus": 7,
  "maxGold": 2100000000,
  "stallMaxItems": 16,
  "stallMinLevel": 10,
  "stallMaxPrice": 2100000000,
  "stallViewRangeM": 10,
  "tradeMaxItems": 8,
  "tradeRangeM": 8,
  "tradeInviteTtlMs": 30000,
  "warehouseSlots": 48,
  "stallSpacingM": 3.5,
  "gearBands": {
    "mid": 15,
    "high": 40
  },
  "mobGold": {
    "base": 2,
    "perLevel": 1.4,
    "perLevelSq": 0.125,
    "minPct": 75,
    "maxPct": 130,
    "riftPct": 110
  },
  "newAccountGift": [
    {
      "item": "novice_xp_scroll",
      "qty": 10
    },
    {
      "item": "novice_gold_scroll",
      "qty": 10
    },
    {
      "item": "novice_speed_scroll",
      "qty": 10
    },
    {
      "item": "novice_hp_scroll",
      "qty": 10
    },
    {
      "item": "novice_defense_scroll",
      "qty": 10
    },
    {
      "item": "novice_attack_scroll",
      "qty": 10
    }
  ],
  "referral": {
    "level": 10,
    "maxRewarded": 10,
    "referrer": [
      {
        "item": "novice_xp_scroll",
        "qty": 5
      },
      {
        "item": "novice_gold_scroll",
        "qty": 5
      }
    ],
    "referred": [
      {
        "item": "novice_xp_scroll",
        "qty": 5
      },
      {
        "item": "novice_gold_scroll",
        "qty": 5
      }
    ]
  },
  "dailyReward": {
    "days": [
      {
        "items": [
          {
            "item": "novice_xp_scroll",
            "qty": 2
          }
        ]
      },
      {
        "items": [
          {
            "item": "novice_gold_scroll",
            "qty": 2
          }
        ]
      },
      {
        "items": [
          {
            "item": "novice_attack_scroll",
            "qty": 2
          },
          {
            "item": "novice_defense_scroll",
            "qty": 2
          }
        ]
      },
      {
        "items": [
          {
            "item": "novice_xp_scroll",
            "qty": 3
          }
        ]
      },
      {
        "items": [
          {
            "item": "wisp_solar",
            "qty": 1,
            "days": 1
          }
        ]
      },
      {
        "items": [
          {
            "item": "novice_hp_scroll",
            "qty": 2
          },
          {
            "item": "novice_speed_scroll",
            "qty": 2
          }
        ]
      },
      {
        "items": [
          {
            "item": "novice_xp_scroll",
            "qty": 3
          },
          {
            "item": "novice_gold_scroll",
            "qty": 3
          }
        ],
        "premiumDays": 1,
        "skin": {
          "id": "skin_crimson",
          "days": 1
        }
      }
    ]
  },
  "firstWeek": {
    "days": 7,
    "goals": [
      {
        "id": "level_5",
        "kind": "level",
        "target": 5,
        "items": [
          {
            "item": "novice_attack_scroll",
            "qty": 3
          }
        ]
      },
      {
        "id": "quests_3",
        "kind": "quests",
        "target": 3,
        "items": [
          {
            "item": "novice_xp_scroll",
            "qty": 3
          }
        ]
      },
      {
        "id": "party",
        "kind": "party",
        "target": 1,
        "items": [
          {
            "item": "novice_gold_scroll",
            "qty": 3
          }
        ]
      },
      {
        "id": "friend",
        "kind": "friend",
        "target": 1,
        "items": [
          {
            "item": "novice_speed_scroll",
            "qty": 3
          }
        ]
      },
      {
        "id": "level_10",
        "kind": "level",
        "target": 10,
        "items": [
          {
            "item": "novice_xp_scroll",
            "qty": 5
          }
        ]
      },
      {
        "id": "upgrade",
        "kind": "upgrade",
        "target": 1,
        "items": [
          {
            "item": "novice_defense_scroll",
            "qty": 3
          },
          {
            "item": "novice_hp_scroll",
            "qty": 3
          }
        ]
      },
      {
        "id": "level_15",
        "kind": "level",
        "target": 15,
        "items": [
          {
            "item": "wings_dawnfeather",
            "qty": 1,
            "days": 1
          }
        ]
      },
      {
        "id": "level_20",
        "kind": "level",
        "target": 20,
        "items": [
          {
            "item": "mantle_lionheart",
            "qty": 1,
            "days": 3
          },
          {
            "item": "novice_xp_scroll",
            "qty": 5
          }
        ]
      }
    ]
  }
}
